"use client";

import { useEffect } from "react";

import { trackMetaEvent } from "@traqly/analytics/client";

/** Consume the short-lived OAuth Lead event ID after the callback redirect. */
export function MetaRegistrationEventHandoff() {
  useEffect(() => {
    const consumeEvents = async () => {
      const events = [["meta_registration_event", "Lead"]] as const;
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (!window.fbq && attempts < 40) return;
        window.clearInterval(timer);

        for (const [cookieName, eventName] of events) {
          const cookie = document.cookie
            .split(";")
            .map((part) => part.trim())
            .find((part) => part.startsWith(`${cookieName}=`));
          if (!cookie) continue;

          const eventId = decodeURIComponent(
            cookie.slice(cookieName.length + 1),
          );
          if (eventId) trackMetaEvent(eventName, {}, { eventID: eventId });
          document.cookie = `${cookieName}=; Max-Age=0; path=/; SameSite=Lax`;
        }
      }, 50);
    };

    void consumeEvents();
  }, []);

  return null;
}
